import { useTranslations } from '@heidi/runtime/i18n';

/**
 * Hook to get the appropriate terminology (CPD or CME) based on user's country.
 * US users see "CME" (Continuing Medical Education), all others see "CPD" (Continuing Professional Development).
 *
 * `isUS` crosses as an argument: the country read is an app-side session
 * concern, resolved at the composition point by `useIsCpdUsUser`.
 */
export function useCPDTerm(isUS: boolean) {
  const { t } = useTranslations();

  return {
    term: isUS ? 'CME' : t('sidenav.cpd'),
    isUS,
  };
}
